export default __webpack_public_path__ + "static/media/m-23.75d8c3a4.svg";